import { render, staticRenderFns } from "./OJTPage.vue?vue&type=template&id=7ac6e385&scoped=true"
import script from "./OJTPage.vue?vue&type=script&lang=js"
export * from "./OJTPage.vue?vue&type=script&lang=js"
import style0 from "./OJTPage.vue?vue&type=style&index=0&id=7ac6e385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac6e385",
  null
  
)

export default component.exports